import QuickLRU from 'quick-lru';
import { apiEndpoint, BACKEND } from '../utils/api';
import { isEmail } from '../utils/validators';

export const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'profile',
});

const availableEmailCache = new QuickLRU({ maxSize: 1000 });

// Check if mail is available. Store results in cache for quicker response times.
// On request error, default to available to not block user
export async function isEmailAvailable(email) {
    if (availableEmailCache.has(email)) return availableEmailCache.get(email);
    if (!email || !isEmail(email)) return true;

    try {
        const { data } = await backendEndpoint.get('check-user-by-email', { params: { email } });
        const emailAvailable = !data.hasUser;
        availableEmailCache.set(email, emailAvailable);
        return emailAvailable;
    } catch {
        return true;
    }
}
